<template>
  <div>
    <ul class="popap__content-checkboxes" v-if="isCategorized">
      <div class="filter-sort-container" v-for="(items, key, index) in categorizedItems" :key="index">
        <div class="filter-sort-letter-container">
                <span class="filter-sort-letter">
                    {{ key }}
                </span>
        </div>
        <div class="filter-sort-checkbox-container">
          <li v-for="[id, item] in items" :key="id">
            <filter-checkbox
                :disabled="!item.active"
                :label="item.title"
                :value="id"
                :limit="limit"
                :hint="item.description ? item.description : item.short_description"
                :filter="filter"
                @click.native.prevent="item.active ? $emit('filter', id) : null"/>
          </li>
        </div>
      </div>
    </ul>
    <ul class="popap__content-checkboxes" v-if="!isCategorized">
          <li v-for="[id, item] in items" :key="id">
            <filter-checkbox
                :disabled="!item.active"
                :label="item.title"
                :value="id"
                :limit="limit"
                :hint="item.description ? item.description : item.short_description"
                :filter="filter"
                @click.native.prevent="item.active ? $emit('filter', id) : null"/>
          </li>
    </ul>
    <div v-if="getFoundCount !== null" class="popap__content-founded">
      Найдено {{ getFoundCount }}
    </div>
  </div>
</template>

<script>
import FilterCheckbox from '@/components/FilterCheckbox'
import {mapGetters} from 'vuex'

export default {
  name: 'filer-block-popup-short',
  props: {
    items: {
      type: Array,
      require: true
    },
    filter: {
      type: Array,
      require: true
    },
    limit: {
      type: [Array, Boolean],
      require: true
    },
    isCategorized: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FilterCheckbox
  },
  computed: {
    ...mapGetters(['getFoundCount']),
    categorizedItems() {
      let categories = {};
      for (let i = 0; i < this.items.length; i++) {
        let item = this.items[i];
        let category = item[1].title.substring(0, 1);
        if (!categories[category]) {
          categories[category] = [];
        }
        categories[category].push(item);
      }
      return categories;
    }
  }
}
</script>